import React, { useState,useEffect} from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import OTPInput, { ResendOTP } from "otp-input-react";
import { useNavigate } from 'react-router-dom';
import Web3 from "web3";
import { toast } from 'react-toastify';
import components from '../../components';
import ApiCall from '../../utils/Api';
import contractABI from '../../utils/contractABI';
const ConnectToWallet = () => {
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress=import.meta.env.VITE_APP_TDUcontractAddress
  const [name,setName]=useState("")
  const [OTP, setOTP] = useState("");

  const [isconnected, setisconnected] = useState(false);
  const [signer, setSigner] = useState(null);
const [txhash,setTxHash]=useState({})
  const [web3, setWeb3] = useState(null);
  const [contracts, setContract] = useState(null);

  useEffect(() => {
    const initContract = async () => {
      try {
        // const contractABI =[
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "_dataUnitId",
        //         "type": "uint256"
        //       }
        //     ],
        //     "name": "buyDataUnit",
        //     "outputs": [],
        //     "stateMutability": "payable",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "string",
        //         "name": "_data",
        //         "type": "string"
        //       },
        //       {
        //         "internalType": "uint256",
        //         "name": "_price",
        //         "type": "uint256"
        //       },
        //       {
        //         "internalType": "string",
        //         "name": "_dataUnitType",
        //         "type": "string"
        //       }
        //     ],
        //     "name": "createDataUnit",
        //     "outputs": [],
        //     "stateMutability": "nonpayable",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "string",
        //         "name": "_name",
        //         "type": "string"
        //       }
        //     ],
        //     "name": "registerProvider",
        //     "outputs": [],
        //     "stateMutability": "nonpayable",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "stateMutability": "nonpayable",
        //     "type": "constructor"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getAllDataUnits",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getAllDataUnitTypes",
        //     "outputs": [
        //       {
        //         "internalType": "string[]",
        //         "name": "",
        //         "type": "string[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getAllProviders",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "address payable",
        //             "name": "walletAddress",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "balance",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "name",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "bool",
        //             "name": "active",
        //             "type": "bool"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "sales",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.Provider[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "_dataUnitId",
        //         "type": "uint256"
        //       }
        //     ],
        //     "name": "getAvailableDataUnitsById",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit",
        //         "name": "",
        //         "type": "tuple"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getBuyerDataUnits",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "_dataUnitId",
        //         "type": "uint256"
        //       }
        //     ],
        //     "name": "getDataUnitRevenue",
        //     "outputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "",
        //         "type": "uint256"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getOwner",
        //     "outputs": [
        //       {
        //         "internalType": "address",
        //         "name": "",
        //         "type": "address"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "address",
        //         "name": "_providerAddress",
        //         "type": "address"
        //       }
        //     ],
        //     "name": "getProviderDataUnits",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "address",
        //         "name": "_providerAddress",
        //         "type": "address"
        //       }
        //     ],
        //     "name": "getProviderDetails",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "address payable",
        //             "name": "walletAddress",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "balance",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "name",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "bool",
        //             "name": "active",
        //             "type": "bool"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "sales",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.Provider",
        //         "name": "",
        //         "type": "tuple"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "address",
        //         "name": "_providerAddress",
        //         "type": "address"
        //       }
        //     ],
        //     "name": "getProviderSales",
        //     "outputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "",
        //         "type": "uint256"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   }
        // ];
      
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage

      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);

  
  


  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        console.log("FLow one")
        setWeb3(web3Instance);
        console.log("Data inside ",web3)
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage

      } catch (error) {
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };

  // const navigate = useNavigate();
  const Navigate= useNavigate()
    const renderSeparator = (index) => {
    if (index === 3) {
      return <span>-</span>;
    }
    return null;
  };
  const inputStyle = {
    width: '2rem', // Adjust the width as needed
    height: '2rem', // Adjust the height as needed
    fontSize: '1.5rem', // Adjust the font size as needed
    border: '1px solid #ccc', // Add a border for the input fields
    borderRadius: '4px', // Add rounded corners
    margin: '0.25rem', // Add some margin between input fields
    textAlign: 'center', // Center the text within the input field
  };

const [ProviderState,setProviderState]=useState({
  email:"",
  Password:"",
  ConfirmPassword:"",
  code:"",
  walletAddress:""
})
const handleChange = (event) => {
  setProviderState({ ...ProviderState, [event.target.name]: event.target.value });
};
  const registerProvider = async () => {
// console.log("Name is Rafay",contracts)
if (!ProviderState.ConfirmPassword || !ProviderState.code ||!name || !ProviderState.email || !WalletAddress || !ProviderState.Password) {
  console.log("🚀 ~ file: registerProviderMain.js:521 ~ registerProvider ~ (!ProviderState.ConfirmPassword || !ProviderState.code ||!name || !ProviderState.email || !WalletAddress || !ProviderState.Password):",ProviderState.ConfirmPassword ,ProviderState.code ,name , ProviderState.email,WalletAddress,ProviderState.Password)
  // Display an error message or handle validation failure as needed
  toast.error("All fields are required");
  return;
}
    try {
      console.log("YOu data")
      console.log(web3)
      setloaderState(true)
      const accounts = await web3.eth.getAccounts();
      console.log("🚀 ~ file: registerProviderMain.js:532 ~ registerProvidernottttt ~ accounts:", accounts)
      const account = accounts[0];
      console.log(account);
      const result = await contracts.methods
        .registerProvider(name)
        .send({ from: account });
      setTxHash(result.transactionHash);
      setloaderState(false)
      if (result?.transactionHash) {
        console.log(result)
        // setShowModal(true);

    const data=await ApiCall.Api.post("/provider/registerProvider",
    {
      "email": ProviderState.email,
      "password" : ProviderState.Password,
      "institutionName" : name,
      "institutionCode": ProviderState.code,
      "walletAddress": WalletAddress
  }
)
console.log("🚀 ~ file: registerDataConsumer.js:67 ~ onSubmit ~ data:", data.data.message)
        setTimeout(() => {
          // setShowModal(false);
          // Navigate("/main");
          
          alert(`${result} jasgfjkgasjgfjasgfjg`)
        }, 5000);
      } else {
        alert("Not transaction DOne Successfully")
        // setShowModal(false);
      }
    } catch (error) {
      setloaderState(false)

      console.log("🚀 ~ file: registerProviderMain.js:559 ~ registerProvider ~ error:", error)
    }

    // setLoading(false);
  };
  const [WalletAddress,setWalletAddress]=useState("")
const [loaderState,setloaderState]=useState()
  const connectWallet = async () => {
    const web3Instance = new Web3(window.ethereum);
    console.log("Sos",web3Instance);
    try {
      // Request user approval to access their accounts
      await window.ethereum.enable();
      console.log("FLow one")
      setWeb3(web3Instance);
      console.log("Data inside ",web3)
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      
      if(accounts.length){
        // Get user's registered wallet addresses
        const data = await ApiCall.SECURE_API.get("/user/GetWalletAddresses");
        const registeredWallets = data.data.data || [];
        
        // Check if the connected account matches any registered wallet
        const connectedAccount = accounts[0].toLowerCase();
        const isRegisteredWallet = registeredWallets.some(wallet => 
          wallet.toLowerCase() === connectedAccount
        );
        
        if (isRegisteredWallet) {
          toast.success("You have connected with a registered wallet address successfully.");
          setWalletAddress(accounts[0]);
          setisconnected(true);
        } else {
          toast.error("Connect Wallet Address registered with this profile");
          // Disconnect the wallet if it's not registered
          setWeb3(null);
          setisconnected(false);
          setWalletAddress("");
        }
      } else {
        toast.error("Something went wrong!");
      }
      
      console.log("🚀 ~ connectWal ~ accounts:", accounts)
      
    } catch (error) {
      console.error(error);
      toast.error("Failed to connect wallet. Please try again.");
    }
   if (window.web3) {
    // Legacy dapp browsers
    const web3Instance = new Web3(window.web3.currentProvider);
    setWeb3(web3Instance);
  } else {
    // Non-dapp browsers
    console.log("Please install MetaMask!");
  }
  };
  return (
    <div style={{ display:"flex",justifyContent:"center",marginTop:"10%", width: "100%", backgroundColor: "#F3F4F8" }}>
          <components.Loader.Back_Drop state={loaderState}/>
         
      <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width:"50%"
        }}>
      <span className='Loginheading'>
                    Connect To Wallet  
            </span>
            <div className='LoginScreen'>
                 <div style={{display:"flex",flexDirection:"column",height:100,justifyContent:"space-evenly"}}>
                      <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                          <span style={{width:"90%", fontFamily: 'Manrope, sans-serif'}}>Connect Your Wallet</span>
                      </div>
                        <div style={{display:"flex",justifyContent:"center",marginTop:10,width:"100%"}}>
                        <Button onClick={connectWallet}  variant="outlined">Connect a wallet via         Meta Mask</Button>    

                        </div>
                 </div>
              

            </div>
      </div>    
    </div>
  )
}

export default ConnectToWallet